export default [
  {
    path: '/apps/canal-venda/list',
    name: 'apps-canal-venda-list',
    component: () => import('@/views/cadastros/info-organizacionais/canal-venda/list/Index.vue'),
    meta: {
      pageTitle: 'Canais de Venda',
    },
  },
];
